import React from 'react';
import Icon from '../../../components/AppIcon';

const TeachingContent = ({ lesson, showTranscript }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-elevation-2">
      {/* Lesson Header */}
      <div className="mb-4">
        <div className="flex items-center gap-2 mb-2">
          <div className="px-2 py-1 bg-primary/10 rounded-md">
            <span className="text-xs font-medium text-primary">
              {lesson?.knowledgeArea}
            </span>
          </div>
          <div className="flex items-center gap-1 text-xs text-muted-foreground">
            <Icon name="Clock" size={12} />
            <span>{lesson?.duration}</span>
          </div>
        </div>
        <h2 className="text-h4 font-heading text-foreground">
          {lesson?.title}
        </h2>
      </div>

      {/* Key Highlights */}
      <div className="mb-6">
        <h3 className="text-sm font-semibold text-foreground mb-3 flex items-center gap-2">
          <Icon name="Lightbulb" size={16} className="text-accent" />
          Key Topics Covered
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          {lesson?.highlights?.map((highlight, index) => (
            <div
              key={index}
              className="flex items-center gap-2 text-sm text-muted-foreground"
            >
              <div className="w-1.5 h-1.5 bg-primary rounded-full flex-shrink-0" />
              <span>{highlight}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Transcript */}
      {showTranscript && (
        <div className="border-t border-border pt-4">
          <h3 className="text-sm font-semibold text-foreground mb-3 flex items-center gap-2">
            <Icon name="FileText" size={16} className="text-secondary" />
            Lesson Transcript
          </h3>
          <div className="bg-muted/50 rounded-lg p-4">
            <p className="text-sm text-foreground leading-relaxed">
              {lesson?.content}
            </p>
          </div>
        </div>
      )}

      {/* Learning Tips */}
      <div className="mt-6 bg-success/10 border border-success/30 rounded-lg p-4">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 mt-0.5">
            <Icon name="BookOpen" size={18} className="text-success" />
          </div>
          <div className="flex-1 min-w-0">
            <h4 className="text-sm font-semibold text-foreground mb-1">
              Learning Tip
            </h4>
            <p className="text-xs text-muted-foreground">
              Follow along with the whiteboard display while listening to the narration. 
              Pause and replay sections as needed to fully understand each concept.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeachingContent;